import React, { useEffect, useState, useRef } from "react";
import './custom-scrollbar.css';
import { NavLink, useLocation } from "react-router-dom";
import {
  IoPersonOutline, IoReceiptOutline
} from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { MdOutlineDashboard } from "react-icons/md";
import { LuClipboardPlus, LuCalendarDays, LuUserRoundCheck, LuUserRoundX } from "react-icons/lu";
import { motion, AnimatePresence } from "framer-motion";
import {
  TbCalendarTime, TbClockPlus, TbChevronDown, TbChevronRight, TbUsersGroup
} from "react-icons/tb";
import { GrUserWorker } from "react-icons/gr";
import { useUser } from "../../context/UserContext";
import { HiMenuAlt2 } from "react-icons/hi";
import { Calendar1, CalendarDays, CalendarRange, LayoutDashboard, Megaphone, TentTree, UsersRound } from 'lucide-react';




function HrSideBar() {
    
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [manualCollapse, setManualCollapse] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [collapseState, setCollapseState] = useState({ apply: false, teamrequests: false });

  const navAreaRef = useRef(null);

  
  useEffect(() => {
    setIsExpanded(false);
  }, [location.pathname]);



  const attendanceReportsLinks = [
    { name: "Daily Attendance", link: "/hr/daily-attendance", icon: Calendar1  },
    { name: "Monthly Attendance", link: "/hr/monthly-attendance", icon: CalendarRange }
  ];


  const emplyeeManageLinks = [
    { name: "Active Employees", link: "/hr/employees/active", icon: LuUserRoundCheck },
    { name: "Inactive Employees", link: "/hr/employees/in-active", icon: LuUserRoundX },
     { name: "Departments", link: "/hr/departments", icon: TentTree },
     { name: "Leave Balance", link: "/hr/employees/leave-balance-management", icon: LuClipboardPlus }
  ];

  const eventsLinks = [
    { name: "Annoucements", link: "/hr/events/annoucements", icon: Megaphone },
    { name: "Holidays", link: "/hr/events/holidays", icon: TentTree }
  ];

  const reportLinks = [
  { name: "Leave Reports", link: "/hr/leave-reports", icon: LuCalendarDays },
  { name: "Com Off Reports", link: "/hr/compOff-reports", icon: SlCalender },
  { name: "On Duty Reports", link: "/hr/onduty-reports", icon: GrUserWorker },
];



  const navLinks = [
    { name: "Dashboard", link: "/hr/dashboard", icon: LayoutDashboard  },
   { section: "Employees", links: emplyeeManageLinks, icon: UsersRound },
     { section: "Events", links: eventsLinks, icon: TbCalendarTime },
    { section: "Attendance", links: attendanceReportsLinks, icon: TbCalendarTime },
    { section: "Reports", links: reportLinks, icon: IoReceiptOutline },
    
  ];

  
  const sidebarVariants = {
    open: { width: "288px", transition: { type: "spring", stiffness: 100, damping: 15 } },
    closed: { width: "80px", transition: { type: "spring", stiffness: 100, damping: 15 } }
  };

  const textVariants = {
    open: { opacity: 1, x: 0, display: "block", transition: { delay: 0.1 } },
    closed: { opacity: 0, x: -10, transitionEnd: { display: "none" } }
  };

  return (
    <div
      className="sidebar-hover"
      onMouseEnter={() => { if (!manualCollapse) setIsExpanded(true); }}
      onMouseLeave={() => { if (!manualCollapse) setIsExpanded(false); }}
    >
      <AnimatePresence>
        {showSidebar && (
          <motion.div
            initial={false}
            animate={isExpanded ? "open" : "closed"}
            variants={sidebarVariants}
            className="h-full bg-black rounded-r-lg flex flex-col items-center fixed top-0 left-0 z-40 p-3"
          >
            <motion.div className="w-full h-12 flex items-center justify-between px-2">
              <NavLink to="/" className="text-red-100 flex items-center">
                <motion.span variants={textVariants} className="text-2xl whitespace-nowrap">
                  {isExpanded && "Hr Panel"}
                </motion.span>
              </NavLink>
              <button onClick={() => setIsExpanded(prev => !prev)} className="text-white hover:bg-slate-700 p-2 rounded-lg">
                <HiMenuAlt2 size={24} />
              </button>
            </motion.div>

            <div
              ref={navAreaRef}
              className={`gap-4 flex flex-col items-start text-xl w-full mt-10 custom-scrollbar ${isExpanded ? '' : 'overflow-hidden'}`}
              style={{ maxHeight: 'calc(100vh - 120px)', overflowY: isExpanded ? 'auto' : 'hidden' }}
            >
              {navLinks.map((entry, index) => (
                entry.section ? (
                  <div key={index} className="w-full">
                    <button
                      className="text-slate-200 flex items-center justify-between w-full px-4 text-left h-10 hover:bg-slate-700 rounded-md"
                      onClick={() => {
                        const key = entry.section.toLowerCase().replace(/\s+/g, '');
                        setCollapseState(prev => ({ ...prev, [key]: !prev[key] }));
                      }}
                    >
                      <div className="flex items-center justify-between w-full">
                        <div className="flex items-center">
                          <entry.icon size={24} className="mr-2" />
                          {isExpanded && <span className="text-xl">{entry.section}</span>}
                        </div>
                        {isExpanded && (
                          collapseState[entry.section.toLowerCase().replace(/\s+/g, '')] ?
                            <TbChevronDown size={20} /> :
                            <TbChevronRight size={20} />
                        )}
                      </div>
                    </button>
                    {isExpanded && collapseState[entry.section.toLowerCase().replace(/\s+/g, '')] && (
                      <div className="pl-6 mt-2 space-y-1">
                        {entry.links.map((item, subIndex) => (
                          <motion.div key={subIndex} whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                            <NavLink
                              to={item.link}
                              onClick={() => {
                                setManualCollapse(true);
                                setIsExpanded(false);
                                setTimeout(() => setManualCollapse(false), 400);
                              }}
                              className={({ isActive }) =>
                                `text-slate-200 w-full py-1.5 px-3 flex items-center rounded-md relative transition-all duration-150 ease-in-out 
                                ${isActive ? "bg-slate-500" : "hover:bg-slate-700 hover:bg-opacity-60"}`
                              }
                            >
                              <item.icon size={18} className="mr-2" />
                              <motion.span variants={textVariants} className="text-sm whitespace-nowrap">{item.name}</motion.span>
                              {item.badge > 0 && (
                                <motion.span className="ml-auto bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
                                  initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 20 }} transition={{ duration: 0.2 }}>
                                  {item.badge}
                                </motion.span>
                              )}
                            </NavLink>
                          </motion.div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <motion.div key={index} whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="w-full">
                    <NavLink
                      to={entry.link}
                      onClick={() => {
                        setManualCollapse(true);
                        setIsExpanded(false);
                        setTimeout(() => setManualCollapse(false), 400);
                      }}
                      className={({ isActive }) =>
                        `text-slate-200 w-full h-12 px-4 flex items-center rounded-lg relative 
                        ${isActive ? "bg-slate-500" : "hover:bg-slate-700 hover:bg-opacity-60"}`
                      }
                    >
                      <entry.icon size={22} />
                      <motion.span variants={textVariants} className="ml-3 whitespace-nowrap">
                        {entry.name}
                      </motion.span>
                    </NavLink>
                  </motion.div>
                )
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default HrSideBar;
